import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}/autoreacts`;

export const getAutoreacts = (guildId) => apiRequest(base(guildId));
export const createAutoreact = (guildId, payload) =>
  apiRequest(base(guildId), { method: "POST", body: payload });
export const deleteAutoreact = (guildId, id) =>
  apiRequest(`${base(guildId)}/${id}`, { method: "DELETE" });
export const toggleAutoreact = (guildId, id) =>
  apiRequest(`${base(guildId)}/${id}/toggle`, { method: "POST" });
